module.exports = __webpack_public_path__ + "img/jijun.3c0efa1f.png";